
class ProcessingInvoiceCell extends InvoiceCell
{
    private statusLabel:MUILabel = null;

    awakeFromHTML(){
        super.awakeFromHTML();
        this.statusLabel = MUIOutlet(this, "status-lbl", "MUILabel");
    }

    setItem(item: DBDocument): void {
        super.setItem(item);
        this.statusLabel.text = MIOLocalizeString("READING_PDF", "Reading PDF...");        
    }
}

